export default __webpack_public_path__ + "static/media/orbitalLogo.9e1c5a28.png";